<template>
  <b-modal
    :id="'contact-partenaire-modal'"
    :cancel-title="$t('Cancel')"
    centered
    no-close-on-backdrop
    :ok-title="$t('Send.report')"
    size="xs"
    @close="emitCloseModal"
    @hide="resetModal"
    @ok="sendContact"
    @submit.stop.prevent="sendContact">
    <template #modal-header="{ close }">
      <div class="modalHeader">
        <div>
          <h5 class="modal-title mb-0">{{ $t('partenaire.Contact') }}</h5>
          <div class="page-subtitle">{{ partenaire.name }}</div>
        </div>
      </div>
    </template>

    <div>
      <b-form ref="formEvent" @submit.stop.prevent="sendContact">
        <b-form-group
          :invalid-feedback="form.mail.invalidFeedback"
          :label="$t('partenaire.Mail') "
          :state="form.mail.state"
          class="medium-label mb-4"
          label-for="mail-input">
          <b-form-input
            id="mail-input"
            v-model="form.mail.value"
            :state="form.mail.state"
            maxlength="250"
            required
            type="email"
            v-on:change="removeInvalidFeedback('mail');">
          </b-form-input>
        </b-form-group>
        <b-form-group
          :invalid-feedback="form.phoneNumber.invalidFeedback"
          :label="$t('partenaire.Phone')"
          :state="form.phoneNumber.state"
          class="medium-label mb-4"
          label-for="phoneNumber-input">
          <b-form-input
            id="phoneNumber-input"
            v-model="form.phoneNumber.value"
            :state="form.phoneNumber.state"
            maxlength="250"
            placeholder="0123456789"
            required
            tabindex="4"
            type="text"
            v-on:change="removeInvalidFeedback('phoneNumber');">
          </b-form-input>
        </b-form-group>
        <b-form-group
          :invalid-feedback="form.infos.invalidFeedback"
          :label="$t('partenaire.Infos')"
          :state="form.infos.state"
          class="medium-label mb-4"
          label-for="infos-input">
          <b-form-textarea
            id="infos-input"
            v-model="form.infos.value">
          </b-form-textarea>
        </b-form-group>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api'
import i18n from "../../i18n";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: 'ContactPartenaireModal',

  components: {
    DatepickerInput
  },

  props: {
    partenaire: {
      type: Object,
      required: true,
    },
    userMail: {
      type: String,
      required: true,
      default: ""
    },
    userPhone: {
      type: String,
      required: true,
      default: ""
    }
  },

  data() {
    return {
      form: {
        mail:
          {
            state: null,
            invalidFeedback: null,
            value: this.userMail
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: this.userPhone
          },
        infos:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
      },
      errorOccurred: false,
    }
  },


  methods: {

    emitCloseModal() {
      this.errorOccurred = false
      this.$emit("didCloseModal")
    },

    resetModal() {
      if (!this.errorOccurred) {
        this.form.mail.value = null
        this.form.phoneNumber.value = null
        this.form.infos.value = null
      }
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    async sendContact($event) {
      const form = this.$refs.formEvent;
      $event.preventDefault();

      if (!form.reportValidity()) {
        this.errorOccurred = true;
        return
      }

      const data = new FormData();
      data.append('phoneNumber', this.form.phoneNumber.value);
      data.append('mail', this.form.mail.value);
      data.append('infos', this.form.infos.value);

      let url = `/partenaire/contact/${this.partenaire.id}`

      try {
        const response = await api({
          method: 'POST',
          url: url,
          data: data
        });

        this.successToast();
        this.errorOccurred = false;
        this.resetModal();
        this.hideModal();
      } catch (error) {
        console.error(error);
        this.errorOccurred = true;
        if (error.response && error.response.status === 403) {
          const invalidField = error.response.data.invalidField;
          this.form[invalidField].state = false;
          this.form[invalidField].invalidFeedback = i18n.t(error.response.data.message);
        }
      }
    },

    hideModal() {
      this.$bvModal.hide('contact-partenaire-modal')
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('partenaire.contactSent'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>
.modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/partenaire/ContactPartenaireModal.vue